/**
 * Formats error messages from the API response
 * Handles cases where errors can be a string, array, or object
 */
export const formatErrorMessage = (error: any): string => {
  if (!error) return 'An unknown error occurred';

  // If error is an object with 'message', use it.
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return String(error.message);
  }

  // If error is a string, use it directly
  if (typeof error === 'string') return error;

  // Last resort: stringify the object
  return JSON.stringify(error);
};

/**
 * Safely gets nested field errors from React Hook Form's errors object
 * Handles dynamic field paths like "owner.firstName" or "additionalContacts[0].email"
 * 
 * @param errors - The errors object from React Hook Form's formState
 * @param fieldPath - Dot-separated path to the field (e.g., "owner.firstName")
 * @returns The error object if found, undefined otherwise
 */
export const getFieldError = (errors: any, fieldPath: string) => {
  const keys = fieldPath.split('.');
  let current = errors;

  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return undefined;
    }
  }

  return current;
};